import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const DetailsRow = ({ label, children }: PropsWithChildren<{ label: string }>) => (
    <Flex
        gap="76px"
        alignItems="flex-start"
        width="100%"
    >
        <Text
            fontVariant="input2"
            color={colorsPalettes.carbon[300]}
            width="100px"
            flexShrink={0}
        >
            {label}
        </Text>
        {children}
    </Flex>
);
